import api from "../utils/api";
import { isGuid } from "../utils/string";
import { pack } from "./alert";

const toIsoOrNull = (value) => {
    if (!value) return null;
    if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? null : value.toISOString();
    }
    return value;
};

const normalizePrevious = (previous = []) =>
    (Array.isArray(previous) ? previous : []).map((entry) => ({
        firstName: entry?.firstName ?? "",
        middleName: entry?.middleName ?? "",
        lastName: entry?.lastName ?? "",
        generation: entry?.generation ?? "",
        reason: entry?.reason ?? "",
    }));

const normalizeNameChange = (payload = {}) => ({
    ...(payload || {}),
    dateOfBirth: toIsoOrNull(payload?.dateOfBirth),
    felon: !!payload?.felon,
    incarcerated: !!payload?.incarcerated,
    probation: !!payload?.probation,
    registered: !!payload?.registered,
    meta: {
        ...((payload?.meta && typeof payload.meta === "object") ? payload.meta : {}),
        previous: normalizePrevious(payload?.meta?.previous),
    },
});

export const getNameChange = ({ uuid }) => async () => {
    try {
        if (!isGuid(uuid)) return { success: false, item: null };

        const res = await api.get(`/cases/profiles/namechanges/i/${uuid}`);
        return res.data;
    } catch (err) {
        console.log(err);
        return { success: false, error: err };
    }
};

export const saveNameChange = (payload = {}) => async (dispatch) => {
    try {
        if (!isGuid(payload?.uuid)) {
            return { success: false, message: "Invalid matter UUID." };
        }

        const res = await api.post(
            `/cases/profiles/namechanges`,
            normalizeNameChange(payload)
        );
        dispatch(pack(["Name change details saved"], "success"));
        return res.data;
    } catch (err) {
        dispatch(
            pack(
                [err?.response?.data?.error?.message || err?.message || "Save failed"],
                "danger"
            )
        );
        return { success: false, error: err };
    }
};
